import { Layout, Section } from 'layout';
import { ReconciliationScreen } from 'pages/reconciliation/screens/reconciliation-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const ReconciliationPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={ReconciliationScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default ReconciliationPage;
